'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { isValidElement, cloneElement } from 'react';
import UIList from '../../list/UIList';
import SubDropdownMenu from '../internal/SubDropdownMenu';
import DropdownMenuOption from '../internal/DropdownMenuOption';
import UIDropdownDivider from '../UIDropdownDivider';
import { warnIfFragment } from '../../utils/devWarnings';
export const renderMenuItem = (option, index) => {
  // case where you just pass in a React element instead of an object (convienience)
  if ( /*#__PURE__*/isValidElement(option)) {
    warnIfFragment(option, 'renderMultiLevelMenu', 'option');
    return /*#__PURE__*/cloneElement(option, {
      key: index
    });
  } // case of passing in a nested menu
  else if (option.label && option.options) {
      const {
        label,
        options
      } = option,
            rest = _objectWithoutPropertiesLoose(option, ["label", "options"]);

      return /*#__PURE__*/_jsx(SubDropdownMenu, Object.assign({
        buttonText: label
      }, rest, {
        options: options
      }), index);
    } // case of passing in an element with options for the menu
    else if (option.label) {
        const {
          label
        } = option,
              rest = _objectWithoutPropertiesLoose(option, ["label"]);

        return /*#__PURE__*/_jsx(DropdownMenuOption, Object.assign({}, rest, {
          children: label
        }), index);
      } // don't return anything if it isn't valid


  return null;
};
export const renderMenu = abstractTree => {
  if (!abstractTree || abstractTree.length === 0) return null;
  return /*#__PURE__*/_jsx(UIList, {
    role: "menu",
    children: abstractTree.map((option, index) => {
      if (Array.isArray(option)) {
        const items = option.map((item, index2) => renderMenuItem(item, index2));

        if (abstractTree.length > index + 1) {
          items.push( /*#__PURE__*/_jsx(UIDropdownDivider, {}));
        }

        return items;
      }

      return renderMenuItem(option, index);
    })
  });
};